import React from 'react';
import moment from 'moment';
import { get, capitalize } from 'lodash';
import TableHeader from '../TableHeader';

const UserMissionsList = ({ missions = [], total = 0, userId = 0 }) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>User #{userId} Missions list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} missions attepmt</p>
        </div>
      </div>

      <div className='Table Table--user-missions'>
        {(() => {
          const columnHeaders = [
            {
              label: 'Mission'
            },
            {
              label: 'Mission Type',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Status',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Reward',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Completed at',
              sortKey: 'completed_at',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Updated at',
              sortKey: 'updated_at',
              className: 'Table__col--ta-c'
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}
        {missions.map((mission, i) => (
          <div className={'Table__row'} key={`mission_${i}`}>
            <div className='Table__col'>{mission.name}</div>
            <div className='Table__col Table__col--ta-c'>{capitalize(mission.missionType)}</div>
            <div className='Table__col Table__col--ta-c'>{mission.status}</div>
            <div className='Table__col Table__col--ta-c'>{mission.reward}</div>

            <div className='Table__col Table__col--ta-c'>
              {mission.completedAt ?
                moment(get(mission, 'completedAt')).format('YYYY-MM-DD HH:mm:ss')
              :
                '-'
              }
            </div>
            <div className='Table__col Table__col--ta-c'>
              {mission.updatedAt ?
                moment(get(mission, 'updatedAt')).format('YYYY-MM-DD HH:mm:ss')
              :
                '-'
              }
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default UserMissionsList
